import { observable, action } from "mobx"
import request from "app/vendor/request"
import config from "app/config"
import { getCurrentApp } from "app/api/localTools"
import ReportStore from "app/stores/pgd/report"

export default class Store {
  @observable chartData = {
    count: [],
    size: [],
    report: []
  }
  @observable report = {}

  constructor() {
    this.report = ReportStore.fromJS()
  }

  @action getTableData = (query) => {
    request.get(`${config.backend}/${getCurrentApp()}/groups/reports${query}`)
      .checkToken()
      .commonDispose()
      .then((res) => {
        this.tableData = res
      })
  }

  @action getChartData = () => {
    request.get(`${config.backend}/${getCurrentApp()}/dashboard`)
      .checkToken()
      .commonDispose()
      .then((res) => {
        this.chartData = res
      })
  }

  @action getTaskDatas = (familyId, taskId) => {
    return request.get(`${config.backend}/pgd/family/${familyId}/tasks/${taskId}/datas`)
      .checkToken()
      .commonDispose()
  }

  @action setTaskDatas = (index, id, data) => {
    const rowIndexInCard = this.tableData[index].reportList.findIndex(item => item.id === id)
    this.tableData[index].reportList[rowIndexInCard].datas = data
  }

  @action shareGroup = (groupId, username) => {
    return request.put(`${config.backend}/pgd/groups/${groupId}/share/${username}`)
      .checkToken()
      .commonDispose()
  }

  @action getHistory = (groupId) => {
    return request.get(`${config.backend}/pgd/family/${groupId}/history`)
      .checkToken()
      .commonDispose()
  }

  @action updateRemarks = () => {

  }
}



// WEBPACK FOOTER //
// ./src/app/stores/pgd/dashboard.js